;(function () {
    window.Ateed.Components.HeaderMicroIndex = function($container) {
      if ($container.length > 0) {
        menu = $container;
        menuOpen = $('.index-menu-open',$container);

        if (menuOpen) {
          menuOpen.click(function(){
            if (menu.hasClass('open')) {
              menu.removeClass('open');
              $('body').removeClass('modal-open');
            } else {
              menu.addClass('open');
              $('body').addClass('modal-open');
            }
          });
        }
        
        
        dropDownMobileClicked = $('nav > .index-menu-wrapper .menu .dropdown-toggle');
        if (dropDownMobileClicked.length > 0) {
          /* Second level menu toggle */
          dropDownMobileClicked.click(function(e){
            moveToSecond($(this));
            e.preventDefault();
          });
          $('.mobile-second-micro-back').click(function(e){
            $('.mobile-second-micro').removeClass('active');
            $('nav > .index-menu-wrapper ul.menu.nav').removeClass('inactive');
            e.preventDefault();
          });
          /* check if we need to show second level on load */
          secondLevelActive = $('nav > .index-menu-wrapper .menu .index-menu-wrapper li.active');
          if (secondLevelActive.length > 0) {
            moveToSecond(secondLevelActive.closest('.index-menu-wrapper').siblings('.dropdown-toggle'));
          }
        }
        
      }
    };
    
    function moveToSecond(el){
      $('.mobile-second-micro ul').html(el.siblings('.index-menu-wrapper').find('.dropdown-menu').children().clone());
      $('.mobile-second-micro').addClass('active');
      $('nav > .index-menu-wrapper ul.menu.nav').addClass('inactive');
      $('.mobile-second-micro .ateed-level-heading a').attr('href', el.attr('href'));
      $('.mobile-second-micro .ateed-level-heading a').text(el.text());
    }

    window.Ateed.Components.HeaderMicro = function($container) {

        var self = this;
        this.$elements = {
            siteContainer: $('body > .dialog-off-canvas-main-canvas > .site-container'),
            container: $container,
            megaMenu: $('.ateed-mega-menu')
        };

        this.$elements.siteContainer.prepend('<div class="ateed-mm-backdrop-micro"></div>');
        this.$elements.backdrop = $('.ateed-mm-backdrop-micro');

        var menuHelper = new Ateed.Components.HeaderMicro.MenuHelper();
        var menuHelperMicro = new Ateed.Components.HeaderMicro.MenuHelperMicro();
        var levelTwoSurplusHandler = new Ateed.Components.HeaderMicro.LevelTwoSurplusCounter();

        if ($('.ateed-header-micro').length > 0) {

            if ($('.ateed-header-micro-nav').length > 0) {
                self.viewModel3 = new Vue({
                    el: '.ateed-header-micro-nav',
                    data: {
                        displayLevelTwoSurplusLinksToggleMicro: false,
                        displayLevelTwoSurplusLinksMicro: false,
                        levelMicro: menuHelperMicro.tree
                    },
                    ready: function() {
                        this.initDocumentClickHandlers();
                        var vm = this;
                        //Do initial surplus element migrations
                        setTimeout(function() {
                            levelTwoSurplusHandler.onLevelTwoChange(vm.onLevelTwoSurplusCalculated);
                        },0);
                        //Needed if user's browser start very small then gets resized bigger
                        $(window).resize(function() {
                            levelTwoSurplusHandler.onLevelTwoChange(vm.onLevelTwoSurplusCalculated);
                        });
                    },
                    methods: {
                        showSecondaryNavSurplusLinksMicro: function() {
                            this.displayLevelTwoSurplusLinksMicro = !this.displayLevelTwoSurplusLinksMicro;
                        },
                        initDocumentClickHandlers: function () {
                            $(document).on('click', function(e) {
                                var $target = $(e.target);
                                if(!matchesSelector($target, '.triple-dots-list | .triple-dots-list li * | .ateed-indicator')) {
                                    this.displayLevelTwoSurplusLinksMicro = false;
                                }
                            }.bind(this));
                        },
                        onLevelTwoSurplusCalculated: function(surplusCount) {
                            if (this.levelMicro !== undefined) {
                                if ($(window).width() > 959) {
                                    //Hide trailing n elements
                                    var max = this.levelMicro.length - 1;
                                    // reset elements each time the size changes
                                    this.levelMicro.forEach(function (child) {
                                        child.isVisible = true;
                                    });
                                    for (var i = max; i > (max - surplusCount); i--) {
                                        var child = this.levelMicro[i];
                                        child.isVisible = false;
                                    }
                                    this.displayLevelTwoSurplusLinksToggleMicro = surplusCount > 0;
                                }
                                else {
                                    this.levelMicro.forEach(function (child) {
                                        child.isVisible = true;
                                    });
                                }
                            }
                        },
                    }
                });
            }

            if ($('.ateed-header-micro-nav-btn').length > 0) {
                self.viewModel2 = new Vue({
                    el: '.ateed-header-micro-nav-btn',
                    data: {
                        openMobileMicroMenu: false
                    },
                    methods: {
                        toggleMobileMicroMenu: function () {
                            this.openMobileMicroMenu = !this.openMobileMicroMenu
                        }
                    }
                })
            }

            self.viewModel = new Vue({
                el: '.ateed-header-micro',
                data: {
                    displaySearch: false,
                    searchValue: '',
                    levelOne: Object.assign({}, menuHelper.levels[0]), //Clone, as mega menu L1&L2 can change, this can't
                    levelTwo: Object.assign({}, menuHelper.levels[1]), //Clone, as mega menu L1&L2 can change, this can't
                    megaLevels: menuHelper.levels,
                    enabled: menuHelper.enabled,
                    displaySectionMenu: false,
                    displayMegaMenu: false
                },
                ready: function() {
                    this.initDocumentClickHandlers();
                },
                computed: {
                    sectionMenuArrowCss: function () {
                        return this.displaySectionMenu ? 'ateed-arrow-up-hollow-xs-interactive' : 'ateed-arrow-down-hollow-xs-interactive'
                    }
                },
                methods: {
                    initDocumentClickHandlers: function(){
                        $(document).on('click', function(e) {
                            var $target = $(e.target);
                            if(!matchesSelector($target, '.ateed-nav-level-1 a|.ateed-nav-level-1 a strong')) {
                                this.displaySectionMenu = false;
                            }
                            if(!matchesSelector($target, '.ateed-nav-level-2-surplus li *|.ateed-nav-level-2 > ul > li a|.ateed-nav-level-2 > ul > li a *|.ateed-mega-menu a *|.ateed-mega-menu a|.ateed-header-menu-toggle')) {
                                this.hideMegaMenu();
                            }
                        }.bind(this));
                    },
                    startSearch: function () {
                        this.displaySearch = true;
                    },
                    clearSearch: function () {
                        this.searchValue = '';
                        $('#keys').val('');
                    },
                    stopSearch: function () {
                        this.searchValue = '';
                        this.displaySearch = false;
                    },
                    /************************* Navigation *************************/
                    _hideLevels: function(level) {
                        for(var i=0; i<this.megaLevels.length; i++) {
                            this.megaLevels[i].isVisible = false;
                        }
                    },
                    onSectionClick: function(node, $event) {
                        //If active node is clicked, let's show section menu
                        if(node.isActive) {
                            this.displaySectionMenu = true;
                        } else {
                            //Section was changed, let's hide all sections to begin with
                            for(var i=0; i<this.levelOne.children.length; i++) {
                                this.levelOne.children[i].isActive = false;
                            }
                            //Set newly selected section to active
                            node.isActive = true;
                            //Hide the section menu
                            this.displaySectionMenu = false;
                            //Recreate level two based on new section
                            this.levelTwo = new Ateed.MenuLevel(node.parent, node, 2, true);
                        }
                        event.preventDefault();
                    },
                    onLevelTwoClick: function(child, event) {
                        if(child.children[0]) {
                            this._hideLevels();
                            this.megaLevels.$set(child.depth, new Ateed.MenuLevel(child.parent, child, child.depth+1, true));
                            this.showMegaMenu();
                            event.preventDefault();
                        }
                    },
                    //Display level of user's current page.
                    displayCurrentLevel: function() {
                        var current = menuHelper.current;
                        this._hideLevels();
                        this.megaLevels.$set(current.depth-1, new Ateed.MenuLevel(current.parent.parent, current.parent, current.depth, true));
                        this.showMegaMenu();
                    },
                    showMegaMenu: function() {
                        var vm = this;
                        setTimeout(function() {
                            self.$elements.backdrop
                            .height($(window).width() < 960 ? $('.ateed-mega-menu').height()-75 : $('.ateed-mega-menu').height())
                            .show();
                            vm.displayMegaMenu = true;
                        },0);
                    },
                    hideMegaMenu: function() {
                        this.displayMegaMenu = false;
                        self.$elements.backdrop.hide();
                    },
                    ascend: function(level, event) {
                        event.preventDefault();
                        this._hideLevels();
                        if(level.number !== 2) { //If we aren't ascending to root level, use level parents
                        this.megaLevels.$set(level.number-2, new Ateed.MenuLevel(level.parent.parent, level.parent, level.number-1, true));
                    } else { //Otherwise must use root of tree.
                        this.megaLevels.$set(level.number-2, new Ateed.MenuLevel(null, menuHelper.tree, level.number-1, true));
                    }
                    this.showMegaMenu();
                },
                descend: function(level, child, event) {
                    if(child.children[0]) {
                        this._hideLevels();
                        this.megaLevels.$set(level.number, new Ateed.MenuLevel(child.parent, child, level.number+1, true));
                        this.showMegaMenu();
                        event.preventDefault();
                    }
                },
                megaMenuArrowCss: function (child) {
                    if (child.isActive) {
                        if (this.displayMegaMenu && this.megaLevels[child.depth].uri === child.uri) return 'ateed-arrow-up-hollow-xs-interactive';
                        else return 'ateed-arrow-down-hollow-xs-interactive';
                    } else {
                        if (this.displayMegaMenu && this.megaLevels[child.depth].uri === child.uri) return 'ateed-arrow-up-hollow-xs';
                        else return 'ateed-arrow-down-hollow-xs';
                    }
                }
            }
        });

        // only show the header after the vue binding has mounted
        $('.ateed-header-micro').show();
    }
};
function matchesSelector($el, selectorsStr) {
    var selectors = selectorsStr.split('|');
    var result = false;
    selectors.forEach(function(selector) {
        if($el.is(selector)) {
            result = true;
        }
    });
    return result;
}
})();
